import { z } from 'zod';
import { http } from './http';

// /settings/public — fonte única DB-driven (marcianus_settings, migração 054/055).
// Marca, cores, flags e moeda vêm daqui. Nada disto é hardcoded no frontend.
const publicSettingsSchema = z.record(z.string(), z.unknown());
export type PublicSettings = Record<string, unknown>;

export async function getPublicSettings(): Promise<PublicSettings> {
  const data = await http.get<unknown>('/settings/public');
  // O core envelopa em { ok, settings:{…} }. Desembrulhamos (tolerante a plano).
  const obj =
    data && typeof data === 'object' && 'settings' in data &&
    typeof (data as { settings?: unknown }).settings === 'object'
      ? (data as { settings: unknown }).settings
      : data;
  return publicSettingsSchema.parse(obj);
}

/** Lê uma chave de branding com segurança (sem fallback de negócio silencioso). */
export function readString(settings: PublicSettings, key: string): string | undefined {
  const v = settings[key];
  return typeof v === 'string' ? v : undefined;
}

export function readBool(settings: PublicSettings, key: string): boolean | undefined {
  const v = settings[key];
  return typeof v === 'boolean' ? v : undefined;
}

export function readNumber(settings: PublicSettings, key: string): number | undefined {
  const v = settings[key];
  return typeof v === 'number' ? v : undefined;
}
